module.exports = __webpack_public_path__ + "img/202408141006599909dk.2cc8a925.jpg";